import AutospinSettingsPartContainer from "@baseUI/component/settings/AutospinSettingsPartContainer";
import UIFacade from "@baseUI/UIFacade";

export default class AutospinSettingsPartContainerDesktop extends AutospinSettingsPartContainer {

    constructor(params) {
        super(params)
    }

    setParametersSizePosition(params){

        const startAutoplayX = 340 - 110 * (UIFacade.model.autospinList.length - 3)
        this.param = {
            panelPopupPosition: {x: 0, y: 0 },
            popupAutoplayCaptionPosition: params.captionPosition,
            lineTop: {x1: -100, y1: 100, x2: 1200, y2: 100 },
            lineMiddle: {x1: -100, y1: 420, x2: 1200, y2: 420 },
            panelAdditionalPosition: {x: 0, y: 150 },
            settingPlayPosition:[params.captionPosition[0]+20, 1000],
            createPartCountNumbers: 7,
            countNumbers: { btn: {width : 190, height: 100, spaceX: 30, spaceY: 40, startX: startAutoplayX, startY: 140}},
            popupAutoplayRoundsPosition:[params.captionPosition[0], 0],
            panelBalance: {x: 0, y: 350},
            balanceLower: { btn: {width : 170, height: 100, spaceX: 20, spaceY: 160, startX: 0, startY: 280}},
            balanceHigher: { btn: {width : 170, height: 100, spaceX: 20, spaceY: 160, startX: 760, startY: 280}},
            popupAutoplaySettingsPosition: [params.captionPosition[0],0],
            popupAutoplayLowerPosition: [200,110],
            popupAutoplayHigherPosition: [940,110]
        }
    }

}
